
export const FAUNA_SECRET = 'fnAE_Fr-LeACWtGK77C7hkRptpdGSjLBd6v68YHQ';
